import React, { useState } from 'react';

// URL fija del icono de la card. Sustituyendo el archivo en Bunny en este path
// se actualiza el icono para todos los usuarios sin necesidad de nuevo build.
// Si la imagen no carga (404 / red), se muestra el emoji como fallback.
const CAMINO_ICON_URL = 'https://agustinos-cdn.b-cdn.net/camino-2026/images/peregrino-home-icon.png';

const CaminoHomeCard = ({ etapasCount = 0, galeriasCount = 0, mochilaCount = 0, onClick }) => {
  const [iconError, setIconError] = useState(false);
  const hasContent = etapasCount > 0 || galeriasCount > 0 || mochilaCount > 0;
  if (!hasContent) return null;

  return (
    <div
      className="mx-5 mb-6 rounded-3xl overflow-hidden shadow-lg"
      style={{
        background: 'linear-gradient(135deg, #b8895c 0%, #8b6b3f 50%, #6b5230 100%)'
      }}
    >
      <div className="px-6 pt-6 pb-3 text-white">
        {/* Área principal clickable: abre por defecto */}
        <div
          role="button"
          tabIndex={0}
          onClick={() => onClick?.()}
          onKeyPress={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onClick?.();
          }}
          className="cursor-pointer hover:opacity-95 transition-opacity"
          aria-label="Abrir sección Camino de Santiago"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1 min-w-0">
              <div className="text-xs uppercase tracking-wider opacity-90 mb-1">
                Especial
              </div>
              <h3 className="text-2xl font-bold leading-tight mb-2">
                Camino de Santiago
              </h3>
              <p className="text-sm opacity-95 leading-relaxed">
                Sigue cada etapa del Camino con los caminantes: ruta del día,
                audio matutino y fotos en directo.
              </p>
            </div>
            <div className="opacity-90 flex-shrink-0" aria-hidden="true"
                 style={{ width: 84, height: 84, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {iconError ? (
                <span style={{ fontSize: '3rem', lineHeight: 1 }}>🎒</span>
              ) : (
                <img
                  src={CAMINO_ICON_URL}
                  alt=""
                  onError={() => setIconError(true)}
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Fila de pills — botones independientes del área principal */}
      <div className="px-6 pb-5 flex flex-wrap gap-2 text-xs">
        {mochilaCount > 0 && (
          <button
            type="button"
            onClick={() => onClick?.('mochila')}
            className="bg-white/25 hover:bg-white/40 transition-colors px-3 py-1 rounded-full text-white font-medium"
            aria-label="Ir a la sección En mi mochila"
          >
            En mi mochila
          </button>
        )}
        {etapasCount > 0 && (
          <button
            type="button"
            onClick={() => onClick?.('etapas')}
            className="bg-white/25 hover:bg-white/40 transition-colors px-3 py-1 rounded-full text-white font-medium"
            aria-label="Ir a etapas del Camino"
          >
            Etapas
          </button>
        )}
        {galeriasCount > 0 && (
          <button
            type="button"
            onClick={() => onClick?.('galeria')}
            className="bg-white/25 hover:bg-white/40 transition-colors px-3 py-1 rounded-full text-white font-medium"
            aria-label="Ir a galerías del Camino"
          >
            Galería
          </button>
        )}
      </div>
    </div>
  );
};

export default CaminoHomeCard;
